import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  makeStyles,
} from '@material-ui/core'
import statsTableStyles from './statsTable.styles'
import StatsTableHeader from './StatsTableHeader'
import {
  GAME_LOG_GROUPS,
  flattenLeaves,
  totalCells,
} from '../../utils/constants/playerStatsColumnGroups'
import {
  getVisibleFederationLeaves,
  filterFederationGroups,
} from '../../utils/helpers/displayStatsMapping'

const useStyles = makeStyles(statsTableStyles)

const PlayerGameLogTable = ({ games, displayStats }) => {
  const classes = useStyles()
  if (!games || games.length === 0) return null

  const visibleLeafKeys = getVisibleFederationLeaves(displayStats)
  const groups = filterFederationGroups(GAME_LOG_GROUPS, visibleLeafKeys)
  const LEAVES = flattenLeaves(groups)

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size='small'>
        <StatsTableHeader groups={groups} leftHeader='Game' />
        <TableBody>
          {games.map((game, index) => {
            const row = totalCells(game.statsTotals)
            return (
              <TableRow key={index} hover>
                <TableCell className={classes.leftCell}>
                  {game.opponentName ? `vs ${game.opponentName}` : ''}
                </TableCell>
                {LEAVES.map(leaf => (
                  <TableCell
                    key={leaf.key}
                    className={classnames(classes.cell, {
                      [classes.categoryBorderLeft]: leaf.firstOfGroup,
                    })}
                  >
                    {row[leaf.key]}
                  </TableCell>
                ))}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

PlayerGameLogTable.propTypes = {
  games: PropTypes.arrayOf(
    PropTypes.shape({
      opponentName: PropTypes.string,
      statsTotals: PropTypes.object,
    }),
  ),
  displayStats: PropTypes.array,
}

export default PlayerGameLogTable
